import { quoteModel } from '@/modules/common/widgets/components/tools/WidgetQuote.vue'

export const quotes: string[] = [
  'به بازخوردهای منفی (انتقادات) توجه کنید و آن را به خصوص از دوستان خود بخواهید … این کار سخت اما فوق العاده مفید است.',
  'برخی آدم ها تغییر را دوست ندارند اما وقتی گزینه موجود دیگر فاجعه باشد باید تغییر را با آغوش باز بپذیرید.',
  'اگر قوانین به گونه ای است که نمی توانید پیشرفت کنید باید با قوانین بجنگید.',
  'همین حالا ریسک کنید و کاری جسورانه انجام دهید، پیشمان نخواهید شد.',
  'دائما به این فکر کنید که چگونه می توانید کارها را بهتر انجام دهید، به زیر سوال بردن خودتان ادامه دهید.',
  'تا زمانی که کنترل اتفاقاتی که برای سبد شما می افتد در دست شما باشد اشکالی ندارد تخم مرغ های خود را در یک سبد قرار دهید.',
  'وقتی هنری فورد ماشین‌های ارزان و معتبر را ساخت، برخی می‌گفتند اسب چه ایرادی داشت [که آن را اختراع کردی]؟ او یک قمار بزرگ کرد و جوابش را گرفت.',
  'صبور بودن مهمترین ویژگی فرد موفق است. شما نباید تا وقتی مجبور نشده‌اید، از هدفتان منصرف شوید.',
  'اولین قدم این است که امکان پذیر بودن آن را اثبات کرد. پس از آن باید درصد احتمال را بررسی نمود.'
]

export const quotesWithQuotee: quoteModel[] = [
  {
    quote: 'ارزش یک فرد باید در آنچه که به او می دهید باشد نه در آنچه که او می تواند دریافت کند.',
    quotee: 'Albert Einstein'
  },
  { quote: 'این قافله عمر عجب می گذرد * دریاب دمی که با طرب می گذرد', quotee: 'خیام' },
  { quote: 'ما نمی توانیم مشکلات را با همان تفکری که مشکل را ایجاد کردیم حل کنیم', quotee: 'Albert Einstein' },
  { quote: 'هنگامی که محدودیت های خود را می پذیریم، فراتر از آن ها می رویم.', quotee: 'Albert Einstein' },
  {
    quote: 'موفقیت یک معلم بدجنس است\n' +
      'چون افراد را گول می زند که فکر کنند هیچ وقت آن را از دست نمی دهند.', quotee: 'Bill Gates'
  },
  {
    quote: 'همه ما به افرادی احتیاج داریم که به ما بازخورد می دهند\n' +
      'چون در این صورت می توانیم بهبود پیدا کنیم.', quotee: 'Bill Gates'
  },
  {
    quote: 'ناراضی ترین مشتریان شما\n' +
      'بزرگترین منبع یادگیری شما هستند.', quotee: 'Bill Gates'
  }
]